<template>
  <div class="container portfolio">
    <div class="row grid justify-content-center">
      <h1>portfolio</h1>
      <div class="col-lg-4 col-sm-6" v-for="item in items" :key="item">
        <div class="portfolio-box">
          <img :src="require(`@/assets/${item.img}`)" alt="Portolio" />
          <div class="overlay">
            <a :href="item.link" target="_blank">
              <font-awesome-icon icon="fa-solid fa-eye" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PortfolioPage",
  data() {
    return {
      popup: false,
      popupImg: "",
      items: [
        {
          // kiks lab
          img: "dukamarket.png",
          link: "https://dukamarket.netlify.app/",
        },
        {
          // kiks lab
          img: "1.jpg",
          link: "https://cranky-bhaskara-60e8dc.netlify.app/",
        },
        {
          // kiks
          img: "6.jpg",
          link: "https://lucid-stallman-9543e0.netlify.app/",
        },
        {
          // memar
          img: "memaar.png",
          link: "https://www.memaar-morshdy.com/",
        },
        {
          // ecommerce
          img: "ecommerce.jpg",
          link: "https://github.com/ibrahimspider2020/ecommerce-vuejs",
        },
        {
          // books
          img: "books.jpg",
          link: "https://github.com/ibrahimspider2020/books-store-vue.js",
        },
        {
          // cars
          img: "cars.webp",
          link: "https://github.com/ibrahimspider2020/carShop-vueJs",
        },
        {
          // foxlaby
          img: "foxlaby.png",
          link: "https://fox-laby.netlify.app/",
        },
        {
          // hamama
          img: "Hmama.png",
          link: "https://hmama-app.netlify.app/",
        },
        {
          // easytrips
          img: "easytrips.png",
          link: "https://easytrips-app.netlify.app/",
        },
        {
          // zaoub
          img: "zaoub.png",
          link: "https://zaoub-app.netlify.app/",
        },
        {
          // w2-group
          img: "w2-group.png",
          link: "https://w2-group.netlify.app/",
        },
        {
          // Milloin
          img: "Milloin.png",
          link: "https://cheery-eclair-6125e1.netlify.app/",
        },
        {
          // master
          img: "master.png",
          link: "https://leafy-tartufo-c2e33e.netlify.app/",
        },
      ],
    };
  },
};
</script>
